/* Hayati Essence V15. Progressive-enhancement quick view with native Shopify Ajax Cart. */
(function(){
 'use strict';
 var dialog=document.getElementById('he-quick-view');
 if(!dialog||typeof dialog.showModal!=='function'||typeof window.fetch!=='function')return;
 var root=document.documentElement, form=document.getElementById('he-qv-form'), image=document.getElementById('he-qv-image');
 var title=document.getElementById('he-qv-title'),desc=document.getElementById('he-qv-desc'),price=document.getElementById('he-qv-price');
 var select=document.getElementById('he-qv-variant'),variantWrap=document.getElementById('he-qv-variant-wrap');
 var qty=document.getElementById('he-qv-quantity'),add=document.getElementById('he-qv-add'),now=document.getElementById('he-qv-now');
 var error=document.getElementById('he-qv-error'),full=document.getElementById('he-qv-full'), opener=null,serial=0,current=null,busy=false;
 var config=window.heTheme||{}, currency=config.currency||'GBP';
 function money(v){
   try { return new Intl.NumberFormat('en-GB',{style:'currency',currency:currency}).format(Number(v)/100); }
   catch(e){return '£'+(Number(v)/100).toFixed(2);}
 }
 function showError(message){error.textContent=message;error.hidden=!message;}
 function setBusy(status){busy=status;add.disabled=status||!current||!current.available;now.disabled=status||!current||!current.available;select.disabled=status;qty.disabled=status;}
 function choose(){
   var id=select.value;
   if(!dialog._variants)return;
   current=dialog._variants.find(function(v){return String(v.id)===String(id);})||null;
   price.textContent=current?money(current.price):'';
   add.textContent=current&&!current.available?'Sold out':'Add to basket';
   showError('');
   setBusy(false);
 }
 function newOption(variant){
   var option=document.createElement('option');option.value=variant.id;
   option.textContent=variant.public_title||variant.title||'Standard';
   option.textContent+=' · '+money(variant.price)+(variant.available?'':' · Sold out');
   option.disabled=!variant.available;
   return option;
 }
 function safePreview(html){
   var block=document.createElement('div');block.innerHTML=html||'';
   block.querySelectorAll('script,style,iframe,object,embed').forEach(function(el){el.remove();});
   return (block.textContent||'').replace(/\s+/g,' ').trim().slice(0,188);
 }
 function close(){if(dialog.open)dialog.close();}
 function open(button){
   if(busy)return;
   var url=button.getAttribute('data-product-url');
   if(!url)return;
   if(!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url)){
     window.location.href=url;return;
   }
   opener=button;serial++;var thisSerial=serial;
   var card=button.closest('.he-card'),selected=card&&card.querySelector('form [name="id"]');
   var wanted=selected?selected.value:null;
   var cardImage=card&&card.querySelector('.he-card__media img');
   var cardTitle=card&&card.querySelector('.he-card__title');
   image.src=cardImage?cardImage.currentSrc||cardImage.src:'';
   image.alt=cardTitle?cardTitle.textContent:'Product photograph';
   title.textContent=cardTitle?cardTitle.textContent:'Product details';
   desc.textContent='Loading product details…';price.textContent='';
   select.replaceChildren();form.hidden=true;full.href=url;qty.value='1';current=null;dialog._variants=null;
   showError('');dialog.showModal();dialog.querySelector('[data-he-qv-close]').focus();
   fetch(url+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
    .then(function(r){if(!r.ok)throw Error('Product information unavailable');return r.json();})
    .then(function(product){
      if(thisSerial!==serial||!dialog.open)return;
      title.textContent=product.title||title.textContent;
      desc.textContent=safePreview(product.description)||'View the full product page for more information.';
      var variants=Array.isArray(product.variants)?product.variants:[];
      dialog._variants=variants;
      variants.forEach(function(v){select.appendChild(newOption(v));});
      var chosen=variants.find(function(v){return String(v.id)===String(wanted)&&v.available;})||variants.find(function(v){return v.available;})||variants[0];
      if(chosen)select.value=String(chosen.id);
      variantWrap.hidden=variants.length===1&&(variants[0].title==='Default Title'||variants[0].public_title===null);
      form.hidden=variants.length===0;
      if(variants.length===0)showError('This product is not available for quick purchase.');
      choose();
    })
    .catch(function(){if(thisSerial!==serial||!dialog.open)return;desc.textContent='Please open the product page to see current details.';showError('Quick view could not load.');});
 }
 function basket(){
   return fetch((config.root||'/')+'?sections=he-cart-drawer',{credentials:'same-origin'})
     .then(function(r){if(!r.ok)throw Error('Could not refresh basket');return r.json();})
     .then(function(parts){
       var holder=document.createElement('div');holder.innerHTML=parts['he-cart-drawer']||'';
       var fresh=holder.querySelector('#he-basket-drawer'),existing=document.getElementById('he-basket-drawer');
       if(!fresh||!existing)throw Error('Basket update unavailable');
       existing.innerHTML=fresh.innerHTML;
       var count=fresh.getAttribute('data-count')||'0';
       document.querySelectorAll('.he-count').forEach(function(el){el.textContent=count;el.setAttribute('data-n',count);});
     });
 }
 function submit(redirect){
   if(busy||!current||!current.available)return;
   if(!form.reportValidity())return;
   var variantId=Number(select.value);
   var quantity=Number(qty.value);
   if(!Number.isSafeInteger(variantId)||variantId<=0||!Number.isSafeInteger(quantity)||quantity<1){
     showError('Please select a valid size and quantity.');return;
   }
   setBusy(true);showError('');
   var payload={items:[{id:variantId,quantity:quantity}]};
   fetch((config.cartAdd||'/cart/add')+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)})
     .then(function(r){return r.json().then(function(j){if(!r.ok)throw Error(j.description||j.message||'Could not add to basket');return j;});})
     .then(function(){
       if(redirect){window.location.href=(config.root||'/')+'checkout';return;}
       return basket().then(function(){close();var trigger=document.querySelector('[data-he-open="basket"]');if(trigger)trigger.click();else window.location.href=(config.root||'/')+'cart';})
         .catch(function(){window.location.href=(config.root||'/')+'cart';});
     })
     .catch(function(e){showError(e.message||'Could not add to basket. Try again.');setBusy(false);});
 }
 document.querySelectorAll('[data-he-quick-view]').forEach(function(button){
   button.addEventListener('click',function(){open(button);});
 });
 select.addEventListener('change',choose);
 form.addEventListener('submit',function(e){e.preventDefault();submit(false);});
 now.addEventListener('click',function(){submit(true);});
 dialog.querySelector('[data-he-qv-close]').addEventListener('click',close);
 dialog.addEventListener('click',function(e){if(e.target===dialog)close();});
 dialog.addEventListener('close',function(){serial++;if(opener&&opener.isConnected)opener.focus();});
 root.classList.add('he-has-qv');
})();